// THIS FILE IS GENERATED. ANY CHANGES TO THIS FILE WILL BE LOST.
import type { TOC } from '@ember/component/template-only';

export interface CropIconSignature {
  Element: SVGSVGElement;
}

export const CropIcon: TOC<CropIconSignature> = <template><svg width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" ...attributes>
<path fill-rule="evenodd" clip-rule="evenodd" d="M7 2H9V6H7V2ZM17 14H15V9H3V7H17V14ZM9 10V15H21V17H7V10H9ZM17 18H15V22H17V18Z"/>
</svg>
</template>;